import * as types from '../types';
import moment from 'moment';
import update from 'immutability-helper';
import {
    VIEW_MODE,
    EDIT_MODE,
    APPLICANT_MODE,
} from '@Utils/constants';

const initialTitle = 'Public Application Form';

const initialDetailForm = {
    companyID: '',
    applicantID: '',
    applicantType: 0,
    applicantStatus: 0,
    remarks: '',
    firstName: '',
    middleName: '',
    lastName: '',
    suffixName: '',
    birthDate: '',
    age: '',
    cityAddress: '',
    zipCode: '',
    contactNumber: '',
    provincialAddress: '',
    provincialContactNumber: '',
    gender: -1,
    civilStatus: -1,
    religion: '',
    emailAddress: '',
    spouseName: '',
    spouseOccupation: '',
    spouseContactNumber: '',
    jobSource: 0,
    others: '',
    availableJob: 0,
    curriculumVitae: [],
    skills: [],
    educationalBackground: [],
    workExperience: [],
    characterReference: [],
    auditTrail: [],
}

const defaultState = {
    title: 'Public Application Form',
    mode: VIEW_MODE,
    loading: true,
    hasLoadedData: false,
    isEditable: false,
    isApplicantView: true,
    detailForm: { ...initialDetailForm },
    curriculumVitae: [],
    alert: {
        show: false,
        title: 'Update Success',
        content: 'Successfully updated record',
        confirmLabel: 'Ok',
        goBacktoListFlag: false,
        onHide: () => { },
    },
    fileUpload: {
        centered: true,
        fileShow: false,
        fileTitle: 'File Upload',
        size: 'lg',
        acceptedFile: ['image/jpeg', 'image/png', 'image/jpg', 'application/pdf'],
        subTitle: 'File must be of PDF, PNG, JPG formats',
    }
};

export default function detailReducer(state = defaultState, action) {
    switch (action.type) {
        case types.CHG_DETAIL_DATA:
            return update(state, {
                detailForm: {
                    [action.payload.name]: { $set: action.payload.data }
                }
            });
        case types.UPD_DETAIL_TITLE:
            return update(state, {
                title: { $set: action.payload }
            });
        case types.UPD_DETAIL_MODE:
            return update(state, {
                mode: { $set: action.payload }
            });
        case types.HAS_DETAIL_LOADED:
            return update(state, {
                hasLoadedData: { $set: action.payload }
            });
        case types.SET_DETAIL_DATA:
            let data = action.payload;
            let initialMode = action.mode === 'view' || action.mode === undefined ? VIEW_MODE : EDIT_MODE;
            let editable = initialMode === EDIT_MODE ? true : false;
            let publicMode = action.mode === 'public' ? true : false;

            return update(state, {
                title: { $set: initialTitle },
                mode: { $set: initialMode },
                isEditable: { $set: editable },
                isApplicantView: { $set: publicMode },
                detailForm: { $set: data },
                alert: { $set: defaultState.alert }
            });
        case types.RESET_ADD_DATA:
            return update(state, {
                detailForm: { $set: initialDetailForm }
            });
        case types.UPD_ADD_ALERT:
            return update(state, {
                alert: { $set: action.payload }
            });
        case types.HIDE_DETAIL_ALERT:
            return update(state, {
                alert: {
                    show: { $set: false }
                }
            });
        case types.SET_DETAIL_ALERT:
            return update(state, {
                alert: { $set: action.payload }
            });
        case types.SET_DETAIL_CONFIRM_MODAL:
            return update(state, {
                confirmModal: { $set: action.payload }
            });
        case types.HIDE_DETAIL_CONFIRM_MODAL:
            return update(state, {
                confirmModal: {
                    show: { $set: false }
                }
            });
        case types.SHOW_DETAIL_CONFIRM_MODAL:
            return update(state, {
                confirmModal: {
                    show: { $set: true }
                }
            });
        case types.SET_ATTACHMENT_DATA:
            return update(state, {
                curriculumVitae: { $set: action.payload }
            });
        case types.CHG_UPLD_FILE:
            return update(state, {
                fileUpload: { $set: action.payload }
            });
        case types.SHW_MODAL_FILE:
            return update(state, {
                fileUpload: {
                    fileShow: { $set: true }
                }
            });
        case types.HIDE_MODAL_FILE:
            return update(state, {
                fileUpload: {
                    fileShow: { $set: false }
                }
            });
        default:
            return state;

    }
}